import { Promise } from 'es6-promise';

function chainedPromise(callbacks, self, args) {
    var chain = Promise.resolve(),
        current = chain,
        deferred,
        resolve,
        reject;

    deferred = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
    });

    callbacks.forEach((clbk) => {
        current = current.then(
            () => clbk.apply(self, args),
            () => reject()
        );
    });

    current.then(
        () => resolve(),
        () => reject()
    );

    return deferred;
}

class EnchantedPromise extends Promise {
    _onerror(error) {
        console.error('Promise error: ', error);
        if (error.stack) {
            console.error('Stack:', error.stack);
        }
    }
}

EnchantedPromise.chained = chainedPromise;

export default EnchantedPromise;
